import { cacheHooks } from '../../hooks/cacheHooks/cacheHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { getGiftcardsCategories_v1 } from '../../queries/getGiftcardsCategories_v1.gql';
import { getPopularSearchResultsV1 } from '../../queries/getPopularSearchResultsV1.gql';
import { getStoreData_v1 } from '../../queries/getStoreData_v1.gql';
import { getUserInfo } from '../../queries/getUserInfo.gql';
import {
  AccountMessages,
  AppDataGiftCardCategories,
  AppDataPopularSearchResults,
  AppDataStoreData,
} from '../../types/Messages';

export const AppDataContainer = () => {
  cacheHooks.useCachedData(
    getGiftcardsCategories_v1,
    messageHooks.useNext(AppDataGiftCardCategories.Categories),
    messageHooks.useNext(AppDataGiftCardCategories.Loading),
    true,
  );

  cacheHooks.useCachedData(
    getPopularSearchResultsV1,
    messageHooks.useNext(AppDataPopularSearchResults.PopularSearchResults),
    messageHooks.useNext(AppDataPopularSearchResults.Loading),
    true,
  );

  cacheHooks.useCachedData(
    getStoreData_v1,
    messageHooks.useNext(AppDataStoreData.StoreData),
    messageHooks.useNext(AppDataStoreData.Loading),
    true,
  );

  cacheHooks.useCachedData(
    getUserInfo,
    messageHooks.useNext(AccountMessages.AccountUserInfo),
    messageHooks.useNext(AccountMessages.AccountUserInfoLoading),
  );

  return null;
};

AppDataContainer.displayName = 'AppDataContainer';
